import type { $Fetch } from 'ofetch';
import type { AlunoVisao360 } from '@/domain/model/AlunoVisao360';
import type { AlunoVisao360Gateway } from '@/application/port/out/AlunoVisao360Gateway';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

/** FASE B.1 — fetch BFF visão 360 (1 request agrega counts + 5 transições). */
export class HttpAlunoVisao360Gateway implements AlunoVisao360Gateway {
  constructor(private readonly client: $Fetch) {}

  async fetchVisao360(alunoId: string): Promise<AlunoVisao360> {
    const res = await this.client<ApiResponse<AlunoVisao360>>(
      `/api/v1/alunos/${encodeURIComponent(alunoId)}/visao-360`,
    );
    assertApiSuccess(res);
    return res.data;
  }
}
